import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../services/api';

export const fetchJobs = createAsyncThunk(
  'jobs/fetchJobs',
  async ({ q = '', filter = '', limit = 100 }, { rejectWithValue }) => {
    try {
      const response = await api.get('/?action=jobs-list', { params: { q, filter, limit } });
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Error');
    }
  }
);

export const toggleJob = createAsyncThunk(
  'jobs/toggleJob',
  async ({ jobId }, { rejectWithValue }) => {
    try {
      const response = await api.post('/?action=jobs-toggle', { job_id: jobId });
      return { jobId, active: response.data.data.active };
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Error');
    }
  }
);

export const toggleFeatured = createAsyncThunk(
  'jobs/toggleFeatured',
  async ({ jobId }, { rejectWithValue }) => {
    try {
      const response = await api.post('/?action=jobs-toggle-featured', { job_id: jobId });
      return { jobId, featured: response.data.data.featured };
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Error');
    }
  }
);

export const deleteJob = createAsyncThunk(
  'jobs/deleteJob',
  async ({ jobId }, { rejectWithValue }) => {
    try {
      const response = await api.post('/?action=jobs-delete', { job_id: jobId });
      return { jobId, message: response.data.message };
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Error al eliminar oferta');
    }
  }
);

const jobsSlice = createSlice({
  name: 'jobs',
  initialState: {
    items: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchJobs.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchJobs.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchJobs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(toggleJob.fulfilled, (state, action) => {
        const job = state.items.find(j => j.id === action.payload.jobId);
        if (job) job.active = action.payload.active;
      })
      .addCase(toggleFeatured.fulfilled, (state, action) => {
        const job = state.items.find(j => j.id === action.payload.jobId);
        if (job) job.featured = action.payload.featured;
      })
      .addCase(deleteJob.fulfilled, (state, action) => {
        state.items = state.items.filter(j => j.id !== action.payload.jobId);
      });
  },
});

export const { clearError } = jobsSlice.actions;
export default jobsSlice.reducer;
